import MainModel from "../../../../components/Models/main-model";
import { brandPalette } from "../../../../constants/brandPalette";
import {
    adminModalBodyProps,
    adminModalContentProps,
    adminModalHeaderProps,
} from "../../../../components/Models/admin-modal-theme";
import {
    Box,
    FormLabel,
    Heading,
    Textarea,
    Button,
    VStack,
    HStack,
} from "@chakra-ui/react";
import { useSelector, useDispatch } from "react-redux";
import { closeSuspendReasonModel } from "../../../../modules/admin-modules/models/Actions";
import { useState } from "react";
import { deleteStudentRequest } from "../../../../modules/admin-modules/students/Actions";

/** Outline presets — must read on both cream (light) and dark surfaces. */
const reasonPresetButtonProps = {
    variant: "outline",
    borderRadius: "12px",
    fontWeight: "800",
    minH: "44px",
    h: "auto",
    py: 3,
    px: 4,
    w: "100%",
    whiteSpace: "normal",
    textAlign: "center",
    borderColor: "var(--border-subtle)",
    color: "var(--text-primary)",
    bg: "var(--surface-muted)",
    _hover: { bg: "var(--surface-canvas)", borderColor: brandPalette.primary },
    _focus: { outline: "none", boxShadow: "0 0 0 3px rgba(91, 13, 22, 0.18)" },
    _active: { bg: "var(--surface-raised)" },
};

const SuspendReasonModal = ({ studentData }) => {
    const openSuspendReason = useSelector((state) => state.model.isOpen33);
    const [reason, setReason] = useState("");
    const dispatch = useDispatch();
    const isLoading = useSelector((state) => state.students.isLoading);


    const header = (
        <Box>
            <Heading
                textAlign="center"
                fontSize="28px"
                fontWeight="800"
                color="var(--text-primary)"
                fontFamily="'Amiri','Tajawal',sans-serif"
            >
                Student suspension reason
            </Heading>
        </Box>
    );

    const handleSuspend = async () => {
        if (reason.trim()) {
            await dispatch(deleteStudentRequest(studentData?.id, reason.trim()));
            dispatch(closeSuspendReasonModel());
            setReason("");
        }
    };

    const closeFunc = () => {
        dispatch(closeSuspendReasonModel());
        setReason("");
    };

    const setReasonText = (reasonText) => () => {
        const subject = studentData?.subject?.name;
        const body =
            `Edutopia: ${subject} -\n\nThe student's account has been suspended due to: ${reasonText}`;
        setReason(body);
        const el = document.getElementById("suspend-reason");
        if (el) el.value = body;
    };

    return (
        <MainModel
            isLoading={isLoading}
            header={header}
            closeFunc={closeFunc}
            openVar={openSuspendReason}
            buttonTitle={"Confirm suspension"}
            buttonFunc={handleSuspend}
            size="2xl"
            contentProps={adminModalContentProps}
            headerProps={adminModalHeaderProps}
            bodyProps={adminModalBodyProps}
        >
            <VStack dir="ltr" spacing={4}>
                <HStack w="100%">
                    <FormLabel fontWeight="700" color="var(--text-primary)">
                        Student: {studentData?.name}
                    </FormLabel>
                </HStack>

                <VStack w="100%" spacing={2}>
                    <Button
                        {...reasonPresetButtonProps}
                        onClick={setReasonText("Non-payment of fees")}
                    >
                        Non-payment of fees
                    </Button>
                    <Button
                        {...reasonPresetButtonProps}
                        onClick={setReasonText("Absence from the center")}
                    >
                        Absence from the center
                    </Button>
                    <Button
                        {...reasonPresetButtonProps}
                        onClick={setReasonText("Failure to submit homework")}
                    >
                        Failure to submit homework
                    </Button>
                    <Button
                        {...reasonPresetButtonProps}
                        onClick={setReasonText("Lack of engagement and accumulated missed sessions")}
                    >
                        Lack of engagement and accumulated missed sessions
                    </Button>
                    <Button
                        {...reasonPresetButtonProps}
                        onClick={setReasonText(
                            "Failure to respond to calls and messages from administration"
                        )}
                    >
                        Failure to respond to calls and messages from administration
                    </Button>
                    <Button
                        {...reasonPresetButtonProps}
                        onClick={setReasonText("Account sharing")}
                    >
                        Account sharing
                    </Button>
                </VStack>

                <Box w="100%">
                    <FormLabel fontWeight="700" color="var(--text-primary)">
                        Reason:
                    </FormLabel>
                    <Textarea
                        id="suspend-reason"
                        bg="var(--surface-muted)"
                        color="var(--text-primary)"
                        border="1px solid"
                        borderColor="var(--border-subtle)"
                        borderRadius="lg"
                        placeholder="Enter suspension reason"
                        _placeholder={{ color: "var(--text-muted)" }}
                        _focus={{
                            borderColor: brandPalette.primary,
                            boxShadow: "0 0 0 1px rgba(91, 13, 22, 0.22)",
                        }}
                        onChange={(e) => setReason(e.target.value)}
                        rows={4}
                    />
                </Box>
            </VStack>
        </MainModel>
    );
};

export default SuspendReasonModal;

